module.exports = __webpack_public_path__ + "static/BoardPaq-bbb065e751477d80cb6de217827e100a.jpg";